<script setup lang="ts">
import SalesPipelineBoard from '@/features/sales/components/SalesPipelineBoard.vue'

definePage({
  path: '/sales/sales-metrics/pipeline',
  name: '/sales/SalesMetrics/pipeline',
  meta: {
    permission: {
      resource: 'SalesMetrics',
      level: 'Read',
    },
  },
})
</script>

<template>
  <Card>
    <template #content>
      <SalesPipelineBoard :show-sales-person-filter="true" />
    </template>
  </Card>
</template>
